var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowStairsSmall = function SvgArrowStairsSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 54,
    viewBox: "0 0 63 54"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.3 52.7 6.5-6.6c.3-.3.3-.9 0-1.3l-1.3-1.3c-.3-.3-.9-.3-1.3 0l-4.6 4.6c-.6.6-1.5.2-1.5-.6v-14c0-2.5-2-4.4-4.4-4.4h-7.1c-1.2 0-2.2-1-2.2-2.2v-8c0-2.5-2-4.4-4.4-4.4H6c-1.2 0-2.2-1-2.2-2.2V1.6c0-.5-.4-.9-.9-.9H1.1c-.5 0-.9.4-.9.9v12c0 2.5 2 4.4 4.4 4.4h8c1.2 0 2.2 1 2.2 2.2v8c0 2.5 2 4.4 4.4 4.4h7.1c1.2 0 2.2 1 2.2 2.2v12.7c0 .8-1 1.2-1.5.6l-4.6-4.6c-.3-.3-.9-.3-1.3 0L20 44.9c-.3.3-.3.9 0 1.3l6.5 6.6c.8.8 2 1.3 3.1 1.3H31c1.3-.1 2.5-.6 3.3-1.4"
  })));
};
export default SvgArrowStairsSmall;